import { Component, inject } from "@angular/core";
import { ProductImage } from "@domain/product/product-image";
import { DisplayConfiguration } from "@domain/project/configurations/monitoring/display-configuration";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { MonitoringProject } from "@domain/project/monitoring-project";
import { ConfiguredProductComponent } from "@project/floorplanner/floorplan-menu/fgds/configured-product/configured-product.component";
import { FloorplanProductMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-product-menu/floorplan-product-menu.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-display-menu",
  imports: [ConfiguredProductComponent, FloorplanProductMenuComponent],
  templateUrl: "./display-menu.component.html",
  styleUrl: "./display-menu.component.scss",
})
export class DisplayMenuComponent {
  private floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplan: Floorplan;

  protected readonly tooltipTextDisplay: string = $localize`:@@global.display:Display`;
  protected readonly fallbackImageUrl = "";

  constructor() {
    this.floorplan = this.floorplanService.selectedFloorplan;
  }

  protected get displays(): readonly DisplayConfiguration[] {
    if (this.floorplan.project instanceof MonitoringProject) {
      return this.floorplan.project.displays;
    }
    return [];
  }

  protected addDisplay(displayConfig: DisplayConfiguration) {
    this.floorplanService.addDisplay(displayConfig);
  }

  protected addPlaceholder() {
    this.floorplanService.addDisplayPlaceholder();
  }

  protected deleteDisplay(displayConfig: DisplayConfiguration) {
    (this.floorplan.project as MonitoringProject).deleteDisplay(displayConfig);
  }

  protected drag(displayConfig: DisplayConfiguration) {
    this.dragDropService.setDragged({ type: DraggedItemType.DISPLAY, config: displayConfig });
  }

  protected getImageUrl(config: DisplayConfiguration) {
    return ProductImage.getCantoSourceUrl(config.display.option.groupImageCantoID ?? "");
  }

  protected dragPlaceholder() {
    this.dragDropService.setDragged({ type: DraggedItemType.DISPLAY_PLACEHOLDER });
  }

  protected updateDisplaysItemTextVisibility(visible: boolean) {
    this.floorplan.floorplanState.updateDisplaysItemTextVisibility(visible);
  }
}
